import React, { ReactNode } from "react";
import { Link, LinkProps } from "react-router-dom";

export const ReactRouterLink: React.FC<LinkProps> = ({
  children,
  to,
  ...rest
}: LinkProps) => {
  return /^https?:\/\//.test(to.toString()) ? (
    <a href={to.toString()} {...rest}>
      {children}
    </a>
  ) : (
    <Link to={to} {...rest}></Link>
  );
};
